// Configuration loader for organization settings
// This file loads the appropriate configuration based on the environment

// Import the configuration files
import defaultConfig from './organization.json';
import demoConfig from './organization.demo.json';

// Determine which config to use based on environment or build setting
const getConfig = () => {
  // Check if we're in demo mode (can be set via environment variable or build flag)
  const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true' || 
                     process.env.NODE_ENV === 'development' && 
                     process.env.REACT_APP_USE_DEMO_CONFIG === 'true';
  
  if (isDemoMode) {
    console.log('📚 Loading demo configuration: Silverpine Book Club');
    return demoConfig;
  }
  
  return defaultConfig;
};

// Export the configuration
export const config = getConfig();

// Export individual sections for convenience
export const organization = config.organization;
export const content = config.content;
export const branding = config.branding;
export const socialMedia = config.socialMedia;

// Helper functions for common use cases
export const getOrgName = () => organization.name;
export const getOrgShortName = () => organization.shortName;
export const getOrgEmoji = () => organization.emoji;

// Generate dynamic page titles
export const getPageTitle = (pageTitle = '') => {
  if (pageTitle) {
    return `${pageTitle} | ${organization.shortName}`;
  }
  return organization.name;
};

// Get back to website link text
export const getBackToWebsiteText = () => {
  return content.backToWebsiteText.replace('website', organization.shortName + ' website');
};

// Apply primary color to CSS custom property
export const applyPrimaryColor = () => {
  if (branding?.primaryColor) {
    document.documentElement.style.setProperty('--primary-color', branding.primaryColor);
  }
  if (branding?.primaryColorLight) {
    document.documentElement.style.setProperty('--primary-color-light', branding.primaryColorLight);
  }
};

export default config;
